const FontSizes = {
  extraLarge: 48,
};

export default FontSizes;
